import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import CBStyleConfig from './plugins/style-config.js'

window.axios = axios;
window.vue = Vue;

Vue.use(CBStyleConfig);
new Vue({
  el: '#app',
  render: h => h(App)
});

document.body.addEventListener("mousedown", function(event) {
  if(event.target == document.body) {
    window.parent.postMessage("close", "*");
  }
});


// WEBPACK FOOTER //
// ./src/main.js